import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  viewBox: "0 0 40 40",
  class: "rewarded_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20 18.333a3.21 3.21 0 0 0 2.354-.979 3.21 3.21 0 0 0 .98-2.354 3.21 3.21 0 0 0-.98-2.354 3.21 3.21 0 0 0-2.354-.98 3.21 3.21 0 0 0-2.354.98 3.21 3.21 0 0 0-.98 2.354c0 .917.327 1.701.98 2.354a3.21 3.21 0 0 0 2.354.98ZM11.667 35v-3.333h6.666V26.5a8.948 8.948 0 0 1-3.645-1.73 7.466 7.466 0 0 1-2.355-3.187c-2.083-.25-3.826-1.16-5.229-2.729C5.701 17.284 5 15.444 5 13.334v-1.667c0-.917.326-1.702.98-2.354a3.21 3.21 0 0 1 2.353-.98h3.334V5h16.666v3.333h3.334a3.21 3.21 0 0 1 2.354.98A3.21 3.21 0 0 1 35 11.666v1.666c0 2.111-.701 3.952-2.104 5.521-1.403 1.57-3.146 2.48-5.23 2.73a7.466 7.466 0 0 1-2.354 3.187 8.948 8.948 0 0 1-3.645 1.729v5.167h6.666V35H11.667Zm0-17v-6.333H8.333v1.666c0 1.056.306 2.007.917 2.854A5.005 5.005 0 0 0 11.667 18Zm16.666 0c1-.361 1.806-.965 2.417-1.813a4.761 4.761 0 0 0 .917-2.854v-1.666h-3.334V18Z"
    }, null, -1)
  ]))]))
}
export default { render: render }